<template>
  <div :class="$style.game">
    <!-- banner -->
    <img :class="$style.banner" :src="gameInfo.banner" alt="" />
    <!-- game -->
    <div :class="$style.game">
      <img :src="gameInfo.logo" alt="" />
      <div :class="$style.inner">
        <h4>{{ gameInfo.appName }}</h4>
        <div :class="$style.tags">
          <span
            v-for="(item, index) in gameInfo.tags"
            :key="index"
            :style="{ color: item.labelInfo }"
            >{{ item.labelName }}</span
          >
        </div>
        <p>
          <span>{{ `${gameInfo.score}分` }}</span
          >｜<span>{{ `${gameInfo.version}版本` }}</span
          >｜<span>{{ gameInfo.depict }}</span>
        </p>
      </div>
      <div :class="$style.download">
        <span>{{ `${gameInfo.score}分` }}</span>
        <Rate
          v-model="rateScore"
          :size="14"
          color="#ffd21e"
          void-icon="star"
          void-color="#eee"
          readonly
        ></Rate>
        <div :class="$style.gift" @click="download(2)">
          <span>{{ gameInfo.giftCount }}</span>
          <img :src="gift" alt="" />
          礼包
        </div>
        <!-- <p>下载盒子APP领取礼包</p> -->
      </div>
    </div>
    <!-- 活动详情 -->
    <div :class="$style.info">
      <h4>游戏截图</h4>
      <div :class="$style.imageBar">
        <div :style="{ width: `${imageBarW}px` }">
          <img
            v-for="(item, index) in gameInfo.shots"
            :key="index"
            :class="gameInfo.imageStyle == 1 ? $style.heng : $style.shu"
            :src="item.image"
            @click="preview(item)"
          />
        </div>
      </div>
      <h4>游戏介绍</h4>
      <div v-html="gameInfo.info" :class="$style.infoDetail"></div>
      <div v-for="(item, index) in gameInfo.details" :key="index">
        <h4>{{ item.name }}</h4>
        <pre v-html="item.context"></pre>
      </div>
    </div>
    <!-- 下载按钮 -->
    <div :class="$style.icon">
      <div :class="$style.btn" @click="download(1)">
        <img :src="down" alt="" />下载
      </div>
    </div>
    <!-- 下载按钮 -->
    <!-- <img :class="$style.icon2" :src="icon" alt="" @click="download(2)" />
    <div :class="$style.placeholder"></div> -->
    <!-- 分享 -->
    <div :class="$style.share" v-show="shareShow" @touchmove.prevent>
      <img :src="share" alt="" />
      <img :src="close" @click="shareShow = false" alt="" />
    </div>
  </div>
</template>

<script>
import { getBtGameDetail } from "@/apis/btBoxActivity.js";
import { Rate } from "vant";
import { ImagePreview } from 'vant';
import { pageLoseTips } from "@/libs/utils";

export default {
  components: { Rate },
  data() {
    return {
      icon: "//static.hzwxbz3.cn/Lianyun/font_end/gameBox/download_icon.png",
      share: "//static.hzwxbz3.cn/Lianyun/font_end/gameBox/share.png",
      close: "//static.hzwxbz3.cn/Lianyun/font_end/gameBox/close.png",
      gift: "//static.hzwxbz3.cn/Lianyun/font_end/gameBox/libao_icon.png",
      down: "//static.hzwxbz3.cn/Lianyun/font_end/gameBox/down.png",
      gameInfo: {},
      shareShow: false,
      isWX: false,
      rateScore: 0,
      imageBarW: 0,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    preview(item) {
      ImagePreview([item.image]);
    },
    async initData() {
      //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      const ua = window.navigator.userAgent.toLowerCase();
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      this.isWX = ua.match(/MicroMessenger/i) == "micromessenger";
      const { appkey } = this.$route.query;
      if (!appkey || isNaN(appkey)) {
        pageLoseTips(this.$toast);
        return
      }
      const r = await getBtGameDetail({ appkey: appkey });
      this.gameInfo = r.data;
      this.rateScore = r.data.score / 2;
      this.imageBarW =
        r.data.imageStyle == 1
          ? r.data.shots.length * 200
          : r.data.shots.length * 121;
    },
    download(type) {
      window.open(
        type == 1 ? this.gameInfo.downloadUrl : this.gameInfo.appUrl,
        "_blank"
      );
    },
  },
};
</script>

<style lang='scss' module>
.game {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .title {
    width: 100%;
    text-align: center;
    font-size: 20px;
    font-family: Source Han Sans CN, Source Han Sans CN-Bold;
    font-weight: 700;
    color: black;
    line-height: 36px;
  }

  .banner {
    width: 100%;
    height: 208px;
    object-fit: cover;
  }

  .game {
    width: 100%;
    height: 80px;
    margin: 14px 0px;
    padding: 0px 0px 0px 25px;
    display: flex;

    > img {
      width: 80px;
      margin-right: 12px;
    }

    .inner {
      width: 140px;
      height: 100%;
      > h4 {
        font-size: 18px;
        font-family: Source Han Sans CN, Source Han Sans CN-Bold;
        font-weight: 700;
        text-align: left;
        color: #333333;
        line-height: 26px;
        margin-bottom: 6px;
      }
      > p {
        width: 100%;
        font-size: 11px;
        font-family: SourceHanSansCN, SourceHanSansCN-Regular;
        font-weight: 400;
        text-align: left;
        color: #999999;
        line-height: 12px;
      }
      .tags {
        width: 100%;
        height: 14px;
        display: flex;
        margin-bottom: 10px;
        > span {
          padding: 1px 2px;
          line-height: 12px;
          box-sizing: border-box;
          border-radius: 4px;
          border-width: 1px;
          border-style: solid;
          text-align: center;
          font-size: 9px;
          margin-right: 4px;
        }
      }
    }

    .download {
      width: 110px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      > span {
        width: 100%;
        font-size: 8px;
        font-family: SourceHanSansCN, SourceHanSansCN-Regular;
        font-weight: 400;
        text-align: center;
        color: #999999;
        line-height: 12px;
      }

      .gift {
        width: 75px;
        height: 28px;
        background: #ffe8ba;
        border-radius: 5px;
        font-size: 12px;
        font-family: Source Han Sans CN, Source Han Sans CN-Bold;
        font-weight: 700;
        color: #ffa800;
        line-height: 28px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 10px 0px 10px 0px;
        position: relative;

        > span {
          position: absolute;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background-color: red;
          right: -4px;
          top: -5px;
          color: #fff;
          line-height: 12px;
          text-align: center;
          font-size: 8px;
          font-weight: 500;
          box-sizing: border-box;
        }

        > img {
          width: 14px;
          margin-right: 6px;
        }
      }
      > p {
        width: 100%;
        font-size: 10px;
        font-family: SourceHanSansCN, SourceHanSansCN-Regular;
        font-weight: 400;
        text-align: center;
        color: #999999;
        line-height: 12px;
      }
    }
  }

  .info {
    width: 360px;
    min-height: 200px;
    background: #f6f6f6;
    border-radius: 8px;
    margin: 0px auto 10px auto;
    padding: 13px 10px 10px 10px;
    .infoDetail {
      color: #999999;
      font-size: 13px;
      line-height: 15px;
    }
    .imageBar {
      width: 100%;
      overflow-x: auto;
      margin-bottom: 10px;
      > div {
        display: flex;
        > img {
          margin-right: 10px;
        }
        .heng {
          width: 200px;
          height: 100px;
          object-fit: cover;
        }
        .shu {
          width: 121px;
          height: 216px;
          object-fit: cover;
        }
      }
    }
    > div {
      margin-bottom: 10px;
    }
    h4 {
      width: 100%;
      font-size: 14px;
      font-family: SourceHanSansCN, SourceHanSansCN-Medium;
      font-weight: 500;
      text-align: left;
      color: #666666;
      line-height: 25px;
      margin-bottom: 6px;
    }
    pre {
      width: 100%;
      font-size: 13px;
      font-family: SourceHanSansCN, SourceHanSansCN-Regular;
      font-weight: 400;
      text-align: justifyLeft;
      color: #999999;
      line-height: 21px;
      white-space: pre-wrap;
      word-wrap: break-word;
    }
  }
  .placeholder {
    width: 100%;
    height: 59px;
  }
  .icon {
    width: 100%;
    height: 59px;
    position: fixed;
    bottom: 0px;
    background: #ffffff;
    box-shadow: 0px -0.35px 35px 0.35px rgba(65, 65, 65, 0.27);
    display: flex;
    justify-content: center;
    align-items: center;

    .btn {
      width: 347px;
      height: 38px;
      background: #ffb017;
      border-radius: 19px;
      line-height: 38px;
      text-align: center;
      font-size: 14px;
      font-family: SourceHanSansCN, SourceHanSansCN-Medium;
      font-weight: 500;
      text-align: center;
      color: #ffffff;
      > img {
        width: 14px;
        margin-right: 6px;
      }
    }
  }
  .icon2 {
    width: 70px;
    position: fixed;
    right: 10px;
    bottom: 60px;
  }
  .share {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 10;
    > img:nth-child(1) {
      width: 100%;
    }
    > img:nth-child(2) {
      width: 20px;
      display: block;
      margin: 30px auto;
    }
  }
}
</style>